import { useCallback } from "react"
import { numberFixToStr, toUnitVal } from "../../../RightPanel/UnitPanel/components/common/utils"
import { getUnitAttributes } from "./VariableTable/attributes"
import { useGetUnitEntity } from "@/pages/Project/hooks/useUnitEntity"

export const useGetDisplayValue = () => {
  const getUnitEntity = useGetUnitEntity()
  return useCallback((units, record) => {
    const allUnits = [...units.lines, ...units.nodes]
    const cellUnit = allUnits.find(cell => cell.id === record.unitId)
    if (!cellUnit) {
      return;
    }
    const attributes = getUnitAttributes(cellUnit)
    const attributeConfig = attributes.find(attr => attr.value === record.attribute)
    if (attributeConfig?.dimCode && record.value !== undefined) {
      const unitEntity = getUnitEntity(attributeConfig?.dimCode)
      const unitVal = toUnitVal(record.value, unitEntity?.unit);
      return numberFixToStr(unitVal, unitEntity?.cutoff)
    }
  }, [getUnitEntity])
}